import { ReactComponent as LeftArrow } from "../../iconColor/chevron-down-outline.svg";
import { convertToJalali } from "../../utils/useConvertToJalali";

const OrderDetailsHeader = ({
  onClick,
  headerLabel,
  tracking_code,
  full_name,
  national_id,
  phone_number,
  showDate,
  showBackBtn,
  maxWidth,
  relat,
  pad,
  marginNeed,
  rightContent,
}: any) => {
  var today = new Date(),
    date =
      today.getFullYear() +
      "-" +
      (today.getMonth() + 1) +
      "-" +
      today.getDate();

  const jalaliDateString = convertToJalali(date);

  return (
    <div
      className={`select-none ${
        relat ? "" : "absolute top-0 w-dashboard-table-mobile-header"
      }  mx-auto ${maxWidth}`}
    >
      <div
        className={`mt-4 ${
          marginNeed ? marginNeed : "mx-10"
        } lg:flex basis-1/6 ${pad ? pad : "py-4"} justify-startll`}
      >
        <div className="lg:absolute lg:bottom-1/2 lg:right-0 lg:translate-y-1/2 lg:translate-x-24 cursor-pointer">
          {showBackBtn && (
            <div className="flex items-center w-fit" onClick={onClick}>
              <div className="-rotate-90">
                <LeftArrow />
              </div>
              <p className="flex text-right  text-gray-800 text-Body-OneLine/14/Regular">
                بازگشت
              </p>
            </div>
          )}
        </div>
        <div
          className={
            !rightContent
              ? "flex flex-col "
              : "flex flex-row justify-between w-full"
          }
        >
          <div>
            {headerLabel && (
              <div className="flex text-right text-gray-800 text-HeadLine/24/Bold">
                <p>{headerLabel}</p>
                {tracking_code && <p>({tracking_code})</p>}
              </div>
            )}
            <div className="flex text-right sm:flex-row flex-col text-Title/14/Regular gap-3 sm:gap-0">
              {showDate && (
                <div className="flex flex-col gap-0 lg:flex-row lg:gap-3  sm:border-l-2  px-2">
                  <p>{jalaliDateString}</p>
                </div>
              )}
              {full_name && (
                <div className="flex flex-col gap-0 lg:flex-row lg:gap-3  sm:border-l-2  px-2">
                  <p className="text-gray-500">خریدار: </p>
                  <p className="text-gray-900">{full_name}</p>
                </div>
              )}
              {national_id && (
                <div className="flex flex-col gap-0 lg:flex-row lg:gap-3  sm:border-l-2  px-2">
                  <p className="text-gray-500">کد ملی: </p>
                  <p className="text-gray-900">{national_id}</p>
                </div>
              )}
              {phone_number && (
                <div className="flex flex-col gap-0 lg:flex-row lg:gap-3 px-2">
                  <p className="text-gray-500">شماره موبایل: </p>
                  <p className="text-gray-900">{phone_number}</p>
                </div>
              )}
            </div>
          </div>
          {rightContent && (
            <div className="flex items-center justify-end mt-4 lg:mt-0">
              {rightContent}
            </div>
          )}
        </div>
        <div></div>
      </div>
    </div>
  );
};

export default OrderDetailsHeader;
